"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursiveLessons = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var context_1 = require("./context");
var CourseAgendaLesson_1 = require("./CourseAgendaLesson");
var RecursiveLessons = function (_a) {
    var lessons = _a.lessons, _b = _a.depth, depth = _b === void 0 ? 0 : _b;
    var _c = (0, context_1.useCourseAgendaContext)(), currentLessonParentLessonsIds = _c.currentLessonParentLessonsIds, currentLesson = _c.currentLesson;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: lessons.map(function (l, index) {
            var _a;
            return ((0, jsx_runtime_1.jsx)(CourseAgendaLesson_1.CourseAgendaLesson, __assign({ defaultOpen: currentLessonParentLessonsIds.includes(l.id) ||
                    (currentLesson === null || currentLesson === void 0 ? void 0 : currentLesson.id) === l.id ||
                    depth > 0, index: index, lesson: l, isSubLesson: depth > 0 }, { children: (0, jsx_runtime_1.jsx)(exports.RecursiveLessons, { lessons: (_a = l.lessons) !== null && _a !== void 0 ? _a : [], depth: depth + 1 }) }), l.id));
        }) }));
};
exports.RecursiveLessons = RecursiveLessons;
